import React, { Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setCoilDetails } from '../../Actions/Configurator.action';

const PanelCoilPacking = ({ id }) => {
  const dispatch = useDispatch();
  const configurator = useSelector((state) => state.configurator);
  const { rules, selections } = configurator;
  const { coilInfo } = rules;
  const { packingOptions } = coilInfo;

  const handleOptionChange = (key, value) => {
    dispatch(setCoilDetails(id, 'packingCoils', key));
  };

  const getSelectedPackingCoil = (key) => {
    const foundPackingCoil = selections.coilDetails.find((coil) => coil.id === id && coil.packingCoils === key);
    return !!foundPackingCoil;
  };

  const checkboxes = Object.entries(packingOptions)
    .filter(([key, value]) => window.__litium.constants.coils.standard.includes(key))
    .map(([key, value]) => (
      <div className='select-option select-option__default' key={'packingOptions' + key}      >
        <label>
          <input type='checkbox' checked disabled value={key} onChange={(e) => { handleOptionChange(key, value); }} />
          {value}
        </label>
      </div>
    ));

  const radioButtons = Object.entries(packingOptions)
    .filter(([key, value]) => !window.__litium.constants.coils.standard.includes(key))
    .map(([key, value]) => (
      <div className='select-option' key={'packingOptions' + key}>
        <label>
          <input type='radio' name='packingCoils' value={key} checked={getSelectedPackingCoil(key)} onChange={(e) => { handleOptionChange(key, value); }} />
          {value}
        </label>
      </div>
    ));

  return (
    <Fragment>
      <div className='accordion-panel__panel_header'></div>
      <div className='accordion-panel__panel_content'>
        <div className='configurator__coil_packing'>
          <div className='coil_packing_body coil_packing_body--no-flex'>
            {checkboxes}
            {radioButtons}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default PanelCoilPacking;
